<template>
  <div>
    <configure-product v-if="data.form.ref" :form="data.form" type="product" />
  </div>
</template>

<script>
import ConfigureProduct from "../ConfigureProduct";
import {useGlobalCart} from "../../../../store/store";

export default {
  name: "Product",
  props: {
    data: {
      required: true,
      default: null
    }
  },
  components: {
    ConfigureProduct
  },
  setup () {
    const cart = useGlobalCart()
    const configs = _config.functionalities.digitalmenu.configs
    return { cart, configs }
  },
  mounted() {
    this.initForm()
  },
  methods: {
    initForm () {
      let unitaryValue = this.data.form.product.unitary_value

      if (!this.data.editing) {
        this.data.form = {
          ref: Date.now(),
          name: this.data.form.product.name,
          code: this.data.form.product.code,
          id: this.data.form.product.id,
          canBeAddedToCart: !!this.data.form.product.attributes,
          tap_flg_item: this.data.form.product.tap_flg_item,
          tap_flg_beer: this.data.form.product.tap_flg_beer,
          flg_separate_print: this.data.form.product.flg_separate_print,
          flg_stock_control: this.data.form.product.flg_stock_control,
          flg_charge_service_fee: this.data.form.product.flg_charge_service_fee,
          discount_value: 0,
          price_list_id: null,
          price_list_product_id: null,
          amount: 1,
          unit_of_measure: this.data.form.product.unit_of_measure,
          unitary_value: parseFloat(unitaryValue),
          total_value: parseFloat(unitaryValue),
          base_value: parseFloat(unitaryValue),
          composition_type: this.data.form.product.composition_type,
          printPoints: this.data.form.product.print_points,
          observation: [],
          removedComponents: [],
          image: this.data.form.product.image,
          product: this.data.form.product,
          plus_additionals_enabled: true,
          tax_value: this.chargeTax ? this.formatValue(unitaryValue * (this.configs.percent_tax / 100)) : 0,
          ...(this.data.form.product.attributes && {attributes: []}),
          ...(this.data.form.product.additionals && {additionals: []})
        }
      }
    }
  },
  computed: {
    chargeTax () {
      return this.configs.enable_service_tax && this.data.form.product.flg_charge_service_fee
    }
  }
}
</script>

<style scoped>

</style>